import { render, staticRenderFns } from "./applyBottom.vue?vue&type=template&id=0497e620&scoped=true&"
import script from "./applyBottom.vue?vue&type=script&lang=js&"
export * from "./applyBottom.vue?vue&type=script&lang=js&"
import style0 from "./applyBottom.vue?vue&type=style&index=0&id=0497e620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497e620",
  null
  
)

export default component.exports